// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1r0M6","delete":"styles_delete__wTjVk","update":"styles_update__2-RnN","add":"styles_add__1163J"};